import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'

const app = initializeApp({
		apiKey: 'AIzaSyD9S72DEFH6Z30K3g7O7TF-vy1_tQf_Zgg',
		authDomain: 'monopoly-bank-63ba8.firebaseapp.com',
		databaseURL:
			'https://monopoly-bank-63ba8-default-rtdb.europe-west1.firebasedatabase.app',
		projectId: 'monopoly-bank-63ba8',
		storageBucket: 'monopoly-bank-63ba8.appspot.com',
		messagingSenderId: '266890006145',
		appId: '1:266890006145:web:1b16994fe821bed993c780',
	}),
	db = getDatabase(app)

export { app, db }
